/* Linsoul product care: resolved returns/warranty terms, the shared information drawer, hero rows and FAQ answers. */
(() => {
  'use strict';

  let data = null;
  let lastTrigger = null;

  const readData = () => {
    const el = document.querySelector('script[data-ls-care-data]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      console.warn('Linsoul care data unreadable', error);
      return null;
    }
  };

  const overlay = (open) => document.dispatchEvent(new CustomEvent('linsoul:overlay', { detail: { open, source: 'care' } }));

  function fillRows() {
    document.querySelectorAll('[data-ls-care-row]').forEach((row) => {
      const topic = data?.topics?.[row.dataset.lsCareOpen];
      if (topic) {
        const title = row.querySelector('[data-ls-care-title]');
        const summary = row.querySelector('[data-ls-care-summary]');
        if (title && topic.title) title.textContent = topic.title;
        if (summary && topic.summary) summary.textContent = topic.summary;
      }
      row.removeAttribute('data-pending');
    });
  }

  function fillAnswers() {
    document.querySelectorAll('[data-ls-care-answer]').forEach((answer) => {
      const topic = data?.topics?.[answer.dataset.lsCareAnswer];
      if (!topic || !topic.detail) return;
      const text = answer.querySelector('[data-ls-care-answer-text]');
      if (text) text.textContent = topic.detail;
      const link = answer.querySelector('[data-ls-care-answer-link]');
      if (link && topic.url) link.href = topic.url;
    });
  }

  function setDispatch(variant) {
    if (!data?.dispatch) return;
    let line = data.dispatch.unknown;
    if (data.preorder) line = data.dispatch.preorder;
    else if (variant && variant.available) line = data.dispatch.in_stock;
    document.querySelectorAll('[data-ls-care-dispatch]').forEach((el) => { el.textContent = line; });
  }

  function drawerFor(topic) {
    const drawer = document.querySelector('[data-ls-care-drawer]');
    if (!drawer) return null;
    const panel = drawer.querySelector(`[data-ls-care-panel="${CSS.escape(topic)}"]`);
    return panel ? { drawer, panel } : null;
  }

  function open(topic, trigger) {
    const target = drawerFor(topic);
    if (!target) return false;
    const { drawer, panel } = target;
    drawer.querySelectorAll('[data-ls-care-panel]').forEach((p) => {
      p.hidden = p !== panel;
      p.querySelector('[data-ls-care-panel-title]')?.removeAttribute('id');
    });
    const title = panel.querySelector('[data-ls-care-panel-title]');
    if (title) title.id = drawer.getAttribute('aria-labelledby');
    const scroller = drawer.querySelector('[data-ls-care-scroll]');
    if (scroller) scroller.scrollTop = 0;
    if (!trigger || !drawer.contains(trigger)) lastTrigger = trigger || null;
    if (!drawer.open) {
      drawer.showModal();
      document.documentElement.classList.add('ls-scroll-lock');
      overlay(true);
    }
    drawer.querySelector('[data-ls-care-close]')?.focus({ preventScroll: true });
    return true;
  }

  function bindDrawer() {
    const drawer = document.querySelector('[data-ls-care-drawer]');
    if (!drawer || drawer.dataset.lsReady) return;
    drawer.dataset.lsReady = '1';
    drawer.querySelectorAll('[data-ls-care-close]').forEach((button) => button.addEventListener('click', () => drawer.close()));
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) drawer.close();
    });
    drawer.addEventListener('close', () => {
      document.documentElement.classList.remove('ls-scroll-lock');
      overlay(false);
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    });
  }

  function init() {
    data = readData();
    bindDrawer();
    fillRows();
    fillAnswers();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ls-care-open]');
    if (!trigger) return;
    if (open(trigger.dataset.lsCareOpen, trigger)) event.preventDefault();
  });

  document.addEventListener('linsoul:product-context', (event) => setDispatch(event.detail?.variant));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
